import { faArrowLeft } from "@jewlr/pro-light-svg-icons/faArrowLeft"
// import { faCube } from "@jewlr/pro-light-svg-icons/faCube"
import { faPlusCircle } from "@jewlr/pro-light-svg-icons/faPlusCircle"
import { faPlus } from "@jewlr/sharp-light-svg-icons/faPlus"
// import { faSquare } from "@jewlr/sharp-light-svg-icons/faSquare"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useEffect, useState, Suspense } from "react"
import { useSelector } from "react-redux"

import withImages from "areas/product/hoc/with-images"
// import { toggleJ3DModal, toggleJ3DV2Modal } from "areas/product/store/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { isTestMode, retry } from "helpers/application"
import { isTouchDevice } from "helpers/browser"
import { isVideoView, isJ3dView } from "helpers/gallery-slide-view"
import useWindowDimensions from "helpers/window-dimensions"
import { cn } from "styles/utils"

import FlipIcon from "./icons/flip-icon"
import Wishlist from "./icons/wishlist"
import MainImageSlider from "./main-image-slider"
import Promo from "./wizard-header/promo"

const ZoomImgModal = loadable(() => retry(() => import("./zoom-img-modal")), {
  ssr: false,
})

const IconButton = ({ ...props }) => (
  <Button
    className="fs-ignore-rage-clicks border-grey-300 text-16 h-34 w-34 rounded-full border bg-white"
    {...props}
  />
)

const ViewButton = ({ className = "", ...props }) => (
  <Button
    className={cn(
      "border-grey-300 text-black-print text-12 leading-20 tablet:bg-none tablet:text-primary tablet:border-none tablet:text-14 tablet:font-medium tablet:h-auto tablet:tracking-normal tablet:leading-16 tablet:my-14 tablet:p-0 tablet:underline tablet:normal-case h-32 rounded-2xl border bg-white px-12 font-semibold uppercase -tracking-tight",
      className
    )}
    {...props}
  />
)

ViewButton.propTypes = {
  className: PropTypes.string,
}

const ImageAreaContent = ({
  currentSlideIndex,
  defaultImage,
  j3dSlideIndex,
  // openJ3DModal,
  // openJ3DV2Modal,
  productTitle,
  // showJ3d,
  // showJ3dV2,
  slidesArray,
  styleCode,
  trackSlide,
  wizardLoading,
}) => {
  const [enableJ3D, setEnableJ3D] = useState(false)
  const [zoomImg, setZoomImg] = useState()
  const { isMobile, isTablet } = useWindowDimensions()
  const showFlip = useSelector((state) => state.wizard.hasFaceComponentOptions)
  const holdbackExp = useSelector(
    (state) => state.experiment.holdback.variant_id
  )

  const showZoomBtn =
    !isVideoView(slidesArray[currentSlideIndex]?.view) &&
    !isJ3dView(slidesArray[currentSlideIndex]?.view) &&
    !wizardLoading
  const showMobileZoomModal =
    (typeof window !== "undefined" && isTouchDevice()) || isTablet

  // Track try-it-on CTA clicks
  const handleTryItOnClick = () => {
    if (!isTestMode) {
      dataLayer.push({
        event: "clicked-try-it-on-cta-pdp",
      })
    }
  }

  // const doViewIn3D = () => {
  //   if (
  //     sl.config.enable_j3d_carousel &&
  //     (showJ3dV2 || showJ3d) &&
  //     j3dSlideIndex >= 0
  //   ) {
  //     trackSlide(j3dSlideIndex)
  //   } else if (showJ3dV2) {
  //     openJ3DV2Modal(true)
  //   } else if (showJ3d) {
  //     openJ3DModal(true)
  //   }
  //   if (!isTestMode) {
  //     dataLayer.push({
  //       event: "viewed-j3d",
  //       styleCode,
  //     })
  //   }
  // }

  useEffect(() => {
    if (currentSlideIndex === j3dSlideIndex && !enableJ3D) {
      setEnableJ3D(true)
    }
  }, [currentSlideIndex])

  useEffect(() => {
    setZoomImg(null)
  }, [currentSlideIndex, showMobileZoomModal, wizardLoading, styleCode])

  useEffect(() => {
    return () => {
      trackSlide(0)
    }
  }, [])

  return (
    <>
      <div
        className={cn(
          "tablet:p-0 tablet:static tablet:top-20 tablet:w-11/12 absolute left-0 z-30 flex w-full items-start justify-between p-16",
          holdbackExp === 0 && "tablet:flex-row flex-row-reverse"
        )}
      >
        <div className="flex flex-col gap-8">
          <Wishlist />
          {sl.config.enable_pdp_image_zoom &&
            typeof window !== "undefined" &&
            showZoomBtn &&
            isMobile &&
            holdbackExp === 1 && (
              <Suspense fallback={<div></div>}>
                <IconButton
                  aria-label="Zoom"
                  onClick={() =>
                    setZoomImg(zoomImg ? null : slidesArray[currentSlideIndex])
                  }
                >
                  <FontAwesomeIcon
                    className="text-black-print text-12"
                    icon={faPlus}
                  />
                </IconButton>
              </Suspense>
            )}
          {/* {(showJ3d || showJ3dV2) &&
            j3dSlideIndex > 0 &&
            currentSlideIndex !== j3dSlideIndex &&
            isMobile && (
              <IconButton
                aria-label="View in 3D"
                onClick={() => doViewIn3D()}
              >
                <FontAwesomeIcon
                    className="text-black-print text-14"
                    icon={faSquare}
                  />
              </IconButton>
            )} */}
        </div>
        <div className="flex flex-col items-end gap-8">
          {holdbackExp === 1 && (
            <Media lessThan="tablet">
              <Promo />
            </Media>
          )}
          {showFlip && <FlipIcon />}
        </div>
      </div>
      <div className="min-h-auto tablet:min-h-325 desktop:min-h-500 relative flex flex-col">
        <MainImageSlider
          defaultImage={defaultImage}
          // enableJ3D={enableJ3D}
          onImageClick={() => {
            if (
              sl.config.enable_pdp_image_zoom &&
              holdbackExp === 0 &&
              isMobile
            ) {
              setZoomImg(zoomImg ? null : slidesArray[currentSlideIndex])
            }
          }}
          zoomImg={zoomImg}
        />

        {/* Temporary Arrow Control for J3D */}
        {sl.config.enable_j3d_carousel &&
          j3dSlideIndex > 0 &&
          currentSlideIndex === j3dSlideIndex &&
          isTablet && (
            <div className="absolute left-0 top-1/2 -translate-y-1/2 p-16">
              <IconButton
                aria-label="Exit 3D View"
                onClick={() => trackSlide(currentSlideIndex - 1)}
              >
                <FontAwesomeIcon
                  className="text-black-print"
                  icon={faArrowLeft}
                />
              </IconButton>
            </div>
          )}
        {/* End of Temporary Arrow Control for J3D */}
        {typeof window !== "undefined" && !wizardLoading && (
          <Suspense fallback={<div />}>
            <div className="tablet:border-t tablet:border-grey-10 tablet:pt-5 tablet:static tablet:w-fit absolute -bottom-24 z-30 mx-auto flex w-full items-center justify-start gap-16 px-16">
              {/* {(showJ3d || showJ3dV2) && !isMobile && (
                <ViewButton onClick={() => doViewIn3D()}>
                  <FontAwesomeIcon
                    className="text-primary tablet:inline-block text-12 mr-6 hidden"
                    icon={faCube}
                  />
                  View in 3D
                </ViewButton>
              )} */}
              {sl.config.enable_pdp_image_zoom &&
                typeof window !== "undefined" &&
                showZoomBtn &&
                !isMobile && (
                  <Suspense fallback={<div></div>}>
                    <>
                      {/* {(showJ3d || showJ3dV2) && (
                        <div className="bg-grey-300 h-16 w-1" />
                      )} */}
                      <ViewButton
                        className="fs-ignore-rage-clicks"
                        onClick={() => {
                          setZoomImg(
                            zoomImg ? null : slidesArray[currentSlideIndex]
                          )
                        }}
                      >
                        <FontAwesomeIcon
                          className="text-primary text-14 mr-6"
                          icon={faPlusCircle}
                        />
                        {isTablet
                          ? "Tap to Zoom"
                          : zoomImg
                            ? "Exit Zoom"
                            : "Zoom"}
                      </ViewButton>
                    </>
                  </Suspense>
                )}
              {holdbackExp === 1 ? (
                <div
                  className={cn(currentSlideIndex === 0 ? "flex" : "hidden")}
                  id="tangiblee-cta"
                  onClick={handleTryItOnClick}
                  onTouchStart={handleTryItOnClick}
                ></div>
              ) : (
                <Media greaterThanOrEqual="tablet">
                  <div
                    className={cn(currentSlideIndex === 0 ? "flex" : "hidden")}
                    id="tangiblee-cta"
                    onClick={handleTryItOnClick}
                    onTouchStart={handleTryItOnClick}
                  ></div>
                </Media>
              )}
            </div>
          </Suspense>
        )}
      </div>
      {sl.config.enable_pdp_image_zoom &&
        showMobileZoomModal &&
        typeof window !== "undefined" && (
          <Suspense fallback={<div></div>}>
            <ZoomImgModal
              onClose={() => setZoomImg(null)}
              productTitle={productTitle}
              zoomImg={zoomImg}
            />
          </Suspense>
        )}
    </>
  )
}

ImageAreaContent.propTypes = {
  currentSlideIndex: PropTypes.number,
  defaultImage: PropTypes.object,
  j3dSlideIndex: PropTypes.number,
  // openJ3DModal: PropTypes.func,
  // openJ3DV2Modal: PropTypes.func,
  productTitle: PropTypes.string,
  setZoomImg: PropTypes.func,
  // showJ3d: PropTypes.bool,
  // showJ3dV2: PropTypes.bool,
  showMobileZoomModal: PropTypes.bool,
  showZoomBtn: PropTypes.bool,
  slidesArray: PropTypes.array,
  styleCode: PropTypes.string,
  trackSlide: PropTypes.func,
  wizardLoading: PropTypes.string,
  zoomImg: PropTypes.object,
}

export default withImages(ImageAreaContent)
